module.exports = __webpack_public_path__ + "img/debicheck.a9e1f9e6.svg";